import ax from '../axios'
import {API_URL} from "../index";
import { IQuestionDetailModal } from "../../constants";

const STORY_QUESTION_URL = API_URL.QUESTION_MODULE;

const getStoryQuestions = (data: IQuestionDetailModal) => {
    return ax.get(`${STORY_QUESTION_URL}/question-group/localization?languageCode=${data.LanguageCode}&storyId=${data.StoryId}`)
}

export {
    getStoryQuestions,
}
